import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { StampApi, ValidateStampNumberQuery } from 'api';

export const findStamp = createAsyncThunk(
  'stamp/findStamp',
  async (option: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await StampApi.filter(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findStampWithEntityForTableList = createAsyncThunk(
  'stamp/findStampWithEntityForTableList',
  async (option: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await StampApi.findWithEntity(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const validateStampNumber = createAsyncThunk(
  'stamp/validateStampNumber',
  async (option: ValidateStampNumberQuery, { rejectWithValue }) => {
    try {
      const response = await StampApi.validateStampNumber(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createStamp = createAsyncThunk(
  'stamp/createStamp',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await StampApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const duplicateStamp = createAsyncThunk(
  'stamp/duplicateStamp',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await StampApi.duplicateStamp(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const activateStamp = createAsyncThunk(
  'stamp/activateStamp',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await StampApi.activateStamp(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface Update {
  id: string;
  body: any;
}
export const updateStamp = createAsyncThunk(
  'product/updateStamp',
  async (params: Update, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await StampApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface FindOne {
  id: string;
  option?: any;
}
export const findOneStamp = createAsyncThunk(
  'stamp/findOneStamp',
  async (params: FindOne, { rejectWithValue }) => {
    try {
      const { id, option } = params;
      const response = await StampApi.findOne(id, option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findStampLogs = createAsyncThunk(
  'stamp/findStampLogs',
  async ({ id, query }: { id: string; query?: any }, { rejectWithValue }) => {
    try {
      const response = await StampApi.findLogs(id, query);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface State {
  tableList: Array<any>;
  list: Array<any>;
  reloadFlag: boolean;
}

const initialState: State = {
  tableList: [],
  list: [],
  reloadFlag: false,
};

const stampSlice = createSlice({
  name: 'stamp',
  initialState,
  reducers: {
    reloadStamp(state) {
      state.reloadFlag = !state.reloadFlag;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(findStampWithEntityForTableList.fulfilled, (state, action) => {
        const { data } = action.payload;
        const newData = data.map(item => {
          return {
            ...item,
            key: item.id,
            value: item.id,
            infoBox: {
              name: item.name,
              code: item.code,
              avatar: item.avatar,
            },
          };
        });

        state.tableList = newData;
      })
      .addCase(findStamp.fulfilled, (state, action) => {
        const { data } = action.payload;
        const newData = data.map(item => {
          return {
            ...item,
            key: item.id,
            value: item.id,
            infoBox: {
              name: item.name,
              code: item.code,
              avatar: item.avatar,
              productOptions: item.productOptions,
            },
          };
        });

        state.list = newData;
      });
  },
});

const { actions, reducer: stampReducer } = stampSlice;

export const { reloadStamp } = actions;

export default stampReducer;
